/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariant {
  brandId?: number;
  brandName?: string;
  cean?: string;
  cfop?: string;
  costPrice?: number;
  cst?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  displayOrder?: number;
  expiration?: string;
  externalId?: number;
  externalStoreUrl?: string;
  extipi?: string;
  genero?: string;
  inStock?: number;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  invoiceName?: string;
  invoicePrice?: number;
  isSellable?: boolean;
  isSellableUrl?: boolean;
  isTradeable?: boolean;
  longExternalStoreUrl?: string;
  maxTradesPerPerson?: number;
  millenniumSKU?: string;
  ncm?: string;
  orderCount?: number;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  salePrice?: number;
  saleStock?: number;
  syncedOnBling?: Date;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  tradeStock?: number;
  unitMeasure?: number;
  unitName?: string;
  variantSummary?: string;
  weight?: number;
  wmsId?: number;
}
